import classNames from 'classnames';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { mapObject, constant } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { BackToCampaignItem, BackToAccountItem } from '@bingads-webui-react/scope-back-button';
import { BackButton } from './back-button';
import { getSummaryBarStyles } from './styles/summary-bar';

export const SummaryBarContainer = ({
  classes,
  texts: { ariaLabel },
  backButtonProps,
  breadcrumb,
  summaryBar,
  showScopeBackButton,
  i18n,
}) => (
  <section
    className={classNames(classes.summaryBar, 'ui-next-summary-bar')}
    aria-label={ariaLabel}
  >
    {
      !backButtonProps && showScopeBackButton && i18n &&
      <>
        <div className={classes.scopeBackButton}>
          <BackToCampaignItem i18n={i18n} />
          <BackToAccountItem i18n={i18n} />
        </div>
        <div className="summary-bar-divider" />
      </>
    }
    {
      backButtonProps && (
        <Fragment>
          <BackButton classes={classes} {...backButtonProps} />
          <div className="summary-bar-divider" />
        </Fragment>
      )
    }
    {breadcrumb}
    {breadcrumb && summaryBar && (<div className="summary-bar-divider" />)}
    {summaryBar}
  </section>
);

SummaryBarContainer.propTypes = {
  classes: PropTypes.shape(mapObject(
    getSummaryBarStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  backButtonProps: PropTypes.shape({
    url: PropTypes.string,
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  }),
  texts: PropTypes.shape({
    ariaLabel: PropTypes.string.isRequired,
  }).isRequired,
  breadcrumb: PropTypes.node,
  summaryBar: PropTypes.node,
  showScopeBackButton: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }),
};

SummaryBarContainer.defaultProps = {
  backButtonProps: null,
  breadcrumb: null,
  summaryBar: null,
  showScopeBackButton: false,
  i18n: null,
};

export const StyledSummaryBarContainer = withDefaultStyles(
  React.memo(SummaryBarContainer),
  getSummaryBarStyles
);
